import { render, staticRenderFns } from "./pagemode.vue?vue&type=template&id=0b9bb074"
import script from "./pagemode.vue?vue&type=script&lang=js"
export * from "./pagemode.vue?vue&type=script&lang=js"
import style0 from "./pagemode.vue?vue&type=style&index=0&id=0b9bb074&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports